export default class StickyAdComponent {
    constructor(
        adContainer = document.getElementById('ads-pos-122-container'),
        topContainer = document.getElementById('medscape-tv').querySelector('aside.ads'),
        bottomContainer = document.getElementById('middle-ad-section'),
        mainContainer = document.getElementById('medscape-tv')
    ) {
        this.adContainer = adContainer;
        this.topContainer = topContainer;
        this.bottomContainer = bottomContainer;
        this.mainContainer = mainContainer;
        this.subscription = null;
        this.isLock = false;
        this.pvbHeight = 0;
    }

    init() {
        let { adContainer } = this;

        if (adContainer != null) {
            adContainer.dataset.style = JSON.stringify({
                "transform": adContainer.style.transform,
                "transition": adContainer.style.transition
            })
            const onTransitionEnd = (e) => {
                this.checkSticky();
            }

            adContainer.addEventListener('transitionend', onTransitionEnd, true);
            const handleScroll = (e) => {
                this.checkSticky();
            }

            window.addEventListener('scroll', handleScroll);
            this.checkSticky();
        }
    }

    onPersistentVideoBarChange(isTransform, height = 0) {
        let { adContainer } = this;
        this.pvbHeight = height;
        this.checkSticky();
        if (this.isLock) {
            if (isTransform) {
                const styleData = {
                    "transform": `translateY(${height}px)`,
                    "transition": `translateY(${height}px)`
                }
                adContainer.dataset.style = JSON.stringify(styleData);
                this.checkSticky();
            }
        } else {
            if (isTransform) {
                adContainer.style.transform = `translateY(${height}px)`;
                adContainer.style.top = `translateY(${height}px)`;
            } else {
                adContainer.style.transition = "";
                adContainer.style.transform = `translateY(0px)`;
            }
            const styleData = {
                "transform": adContainer.style.transform,
                "transition": adContainer.style.transition
            }
            adContainer.dataset.style = JSON.stringify(styleData);
        }

    }
    checkSticky() {
        const { scrollY } = window;

        let { pvbHeight, adContainer, topContainer, bottomContainer, mainContainer } = this;

        const topY = mainContainer.offsetTop + topContainer.offsetTop;


        const adHeight = adContainer.offsetHeight;
        const bottomY = bottomContainer.offsetTop;

        let isBottom = false;
        if (adContainer.style.position === "fixed") {
            isBottom = (pvbHeight + scrollY + adContainer.offsetTop + adHeight + 20) > bottomY;
        } else if (adContainer.style.position === "absolute") {
            isBottom = pvbHeight + scrollY > (mainContainer.offsetTop + adContainer.offsetTop);
        }

        if (window.breakpoint < 3 || topY >= scrollY) {
            this.removeSticky();
        } else if (topY < scrollY && isBottom === false) {
            this.setSticky();
        } else {
            this.lockBottom();
        }

    }
    removeSticky() {
        let { adContainer } = this;
        //let width = adContainer.offsetWidth;

        adContainer.style.transition = "";
        adContainer.style.transform = "";
        adContainer.style.position = "";
        adContainer.style.left = "";
        adContainer.style.top = "";
        adContainer.style.width = "";

        this.isLock = false;

    }
    lockBottom() {
        let { adContainer, topContainer, bottomContainer, mainContainer } = this;
        let botTop = bottomContainer.offsetTop;
        let adTop = botTop - adContainer.offsetHeight - 20 - mainContainer.offsetTop;
        const width = topContainer.offsetWidth;
        adContainer.style.position = "absolute";
        adContainer.style.width = `${width}px`;
        adContainer.style.left = "";
        adContainer.style.transition = "none";
        adContainer.style.transform = "none";
        adContainer.style.top = `${adTop}px`;
        //adContainer.style.bottom = `0`;
        this.isLock = true;

    }
    setSticky() {
        let { adContainer, topContainer } = this;
        const width = topContainer.offsetWidth;
        const leftPos = topContainer.getBoundingClientRect().left;

        const styleData = adContainer.dataset.style != null ? JSON.parse(adContainer.dataset.style) : {};
        let { transform } = styleData;
        adContainer.style.width = `${width}px`;
        adContainer.style.position = "fixed";
        adContainer.style.left = `${leftPos}px`;
        adContainer.style.top = `20px`;
        //adContainer.style.bottom = ``;
        //adContainer.style.transition = transition || "";
        adContainer.style.transform = transform || "";
        this.isLock = false;

    }

}